import React from 'react';
import { FormContentHeader } from '../atoms/FormContentHeader';
import { FormContent } from './FormContent';

export const Form: React.FC<{
  title: string;
  children: React.ReactNode;
  id?: string;
}> = (props) => {
  return (
    <>
      <FormContentHeader label={props.title} id={props.id} />
      <FormContent>{props.children}</FormContent>
    </>
  );
};
